import styled from 'styled-components'

export const Link = styled.a`
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 20px;
  right: 20px;
  background-color: #00e676;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 1px 1px 2px #000;
  z-index: 5;
`

export const Icon = styled.i`
  margin-top: 16px;
`
